



















































import { Component, Vue } from 'vue-property-decorator';
import { backendService } from '@/services/backend-service';
import { ChartOptions, ScatterDataPoint } from 'chart.js';
import moment from 'moment';

import ChartHelper from '@/core/ChartHelper';
import DeliveryHelper  from '@/core/DeliveryHelper';
import DynamicLineChartComponent from '@/components/DynamicLineChartComponent.vue';
import { IDelivery, IDynamicLineChartModel } from '@/core/models';
import { TimeSeriesField } from '@/core/TimeSeriesField';

@Component({
  name: 'MyDevelopement',
  components: {
    DynamicLineChartComponent
  },
})
export default class extends Vue {
  busyState = true;
  items: IDelivery[] = [];
  uniqueDeliveries: IDelivery[] = [];
  dataset: ScatterDataPoint[] = [];
  options!: ChartOptions;
  labels!: moment.Moment[];
  labelsData: string = "";
  charts : IDynamicLineChartModel[]= [];
  today = new Date()
  firstDayMonth = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
  chosenTimeMonths = 1 
  
  private ChartHelper: ChartHelper = new ChartHelper();

  mounted() {
    this.charts= [
    {id: 1, property: TimeSeriesField.Fuktighet, labelsData: "Fuktighet", yAxisLabel: "Fuktighet %", dataset: this.dataset, options: this.options, labels: this.labels, monthLabels: 3},
    {id: 2, property: TimeSeriesField.Plast, labelsData: "Plast", yAxisLabel: "Plast %",  dataset: this.dataset, options: this.options, labels: this.labels, monthLabels: 3},
    {id: 3, property: TimeSeriesField.BP, labelsData: "Bølgepapp", yAxisLabel: "Bølgepapp %", dataset: this.dataset, options: this.options, labels: this.labels, monthLabels: 3}
    ]

    backendService
      .getDeliveriesWithReportData(this.firstDayMonth,this.today)
      .then(res => {
        this.$root.$data.statusMessage = 'Leveranser hentet!';
        this.items = JSON.parse(res.request.response).response; 
        this.uniqueDeliveries = DeliveryHelper.getUniqueDeliveries(JSON.parse(res.request.response).response);
        this.setChartData(1);
        this.busyState = false;
      })
      .catch(err => {
        this.$root.$data.statusMessage = 'Leveranser ikke funnet!';
      });
  }

  setChartData(months: number) {
    this.charts.forEach(element => {
        element["options"] = this.ChartHelper.getChartOptionsMonth(element["labelsData"], element["yAxisLabel"]);
        element["labels"] = this.ChartHelper.getMonthLabels(moment(), months);
        element["dataset"] = this.ChartHelper.getDataSetByMonths(
        element["property"],
        moment().subtract(months, 'months'),
        months,
        this.uniqueDeliveries
      );
    });
  }
  getData(months: number) {
    this.busyState = true
    if (months == -1)  months = (moment().year() - moment("2015-01-01").year()) * 12 + moment().month() // "2015 first year of manual tests"
    
    this.chosenTimeMonths = months;
    backendService
      .getDeliveriesWithReportData(new Date(moment().add(-months, 'months').toISOString()),this.today)
      .then(res => {
        this.$root.$data.statusMessage = 'Leveranser hentet!';
        this.items = JSON.parse(res.request.response).response; 
        this.uniqueDeliveries = DeliveryHelper.getUniqueDeliveries(JSON.parse(res.request.response).response);
        this.setChartData(months);
        this.busyState = false;
      })
      .catch(err => {
        this.$root.$data.statusMessage = 'Leveranser ikke funnet!';
      });
  }
}
